import Vue from 'vue'
import {API, client} from '@/services/http'

const httpPlugin = {
    install: (Vue) => {
        Vue.prototype.$client = client
        Vue.prototype.$API = API
    }
}

Vue.use(httpPlugin)
